(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};


const Animations = svs.tur.ball.row.animations.Core;
const HuxFluxAnimations = svs.tur.ball.row.animations.HuxFlux;
class Default extends svs.tur.Base {
  constructor(options) {
    var _options$BallClass;
    options.className = 'ball-row';
    super(options);
    this.hideWinInfo = options.hideWinInfo;
    this._BallClass = (_options$BallClass = options.BallClass) !== null && _options$BallClass !== void 0 ? _options$BallClass : svs.tur.ball.Default;
    this._regularBalls = [];
    this._extraBalls = [];
    this.isWin = false;
    this.addClass(...this.classNames());
    if (options.align === 'left') {
      this.addClass('ball-row-align-left');
    }
    this.createDomElements();
    this.createBalls();
  }
  createBalls() {
    if (this.numbers) {
      const extraNumbers = this.appendExtraNumbers !== false ? this.extraNumbers : [];
      if (Array.isArray(this.numbers)) {
        this.numbers.forEach((number, i) => {
          this.append(this.createBall({
            number,
            initIndex: i
          }));
        });
        if (extraNumbers && extraNumbers.length) {
          extraNumbers.forEach((number, i) => {
            this.append(this.createBall({
              number,
              extraNumber: true,
              initIndex: i
            }));
          });
        }
      } else {
        this.createEmptyBalls(this.numbers, extraNumbers);
      }
    }
  }
  createEmptyBalls(numbers, extraNumbers) {
    const balls = [];
    for (let i = 0; i < numbers; i++) {
      this.append(new this._BallClass({}));
    }
    if (extraNumbers) {
      for (let j = 0; j < extraNumbers; j++) {
        this.append(new this._BallClass({
          extraNumber: true
        }));
      }
    }
    return balls;
  }
  createDomElements() {
    this.$inner = this.createElement('inner');
    this.$balls = this.createElement('numbers');
    this.$ballsRegular = this.createElement('numbers-regular');
    this.$balls.appendChild(this.$ballsRegular);
    this.$ballsExtra = this.createElement('numbers-extra');
    this.$balls.appendChild(this.$ballsExtra);
    this.$inner.appendChild(this.$balls);
    if (this.showWinInfo) {
      this.$el.setAttribute('data-wininfo', 'true');
      this.addWinInfo();
    }
    if (this.description) {
      this.$el.appendChild(this.description.render());
    }
    this.$el.appendChild(this.$inner);
    if (this.winPlan) {
      this.$el.appendChild(this.winPlan.render());
    }
    if (this.size) {
      this.$el.setAttribute('data-size', this.size);
    }
  }
  append(ball) {
    let insertBeforeNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (ball.extraNumber) {
      this._extraBalls.push(ball);
      this.$ballsExtra.insertBefore(ball.render(), insertBeforeNode);
    } else {
      this._regularBalls.push(ball);
      this.$ballsRegular.insertBefore(ball.render(), insertBeforeNode);
    }
  }
  createBall(_ref) {
    let number = _ref.number,
      extraNumber = _ref.extraNumber,
      empty = _ref.empty,
      initIndex = _ref.initIndex;
    return new this._BallClass({
      number,
      extraNumber,
      empty,
      initIndex,
      drawNumber: this.drawNumber
    });
  }
  get(_ref2) {
    let _ref2$index = _ref2.index,
      index = _ref2$index === void 0 ? null : _ref2$index,
      _ref2$number = _ref2.number,
      number = _ref2$number === void 0 ? null : _ref2$number,
      _ref2$extraNumber = _ref2.extraNumber,
      extraNumber = _ref2$extraNumber === void 0 ? false : _ref2$extraNumber;
    if (index !== null) {
      if (extraNumber) {
        index += this._regularBalls.length;
      }
      return this.balls[index];
    } else if (number !== null) {
      return _.first(_.where(this.balls, {
        number,
        extraNumber
      }));
    }
    return false;
  }
  add(_ref3) {
    let _ref3$number = _ref3.number,
      number = _ref3$number === void 0 ? undefined : _ref3$number,
      _ref3$extraNumber = _ref3.extraNumber,
      extraNumber = _ref3$extraNumber === void 0 ? false : _ref3$extraNumber,
      _ref3$empty = _ref3.empty,
      empty = _ref3$empty === void 0 ? false : _ref3$empty,
      _ref3$animate = _ref3.animate,
      animate = _ref3$animate === void 0 ? true : _ref3$animate,
      _ref3$insertBeforeNod = _ref3.insertBeforeNode,
      insertBeforeNode = _ref3$insertBeforeNod === void 0 ? null : _ref3$insertBeforeNod;
    const ball = this.createBall({
      number,
      extraNumber,
      empty,
      initIndex: empty ? 100 : number
    });
    this.append(ball, insertBeforeNode);
    return animate ? ball.grow() : ball;
  }
  order() {
    this._regularBalls = _.sortBy(this._regularBalls, 'number');
    this._extraBalls = _.sortBy(this._extraBalls, 'number');
  }
  remove(_ref4) {
    let index = _ref4.index,
      number = _ref4.number,
      ball = _ref4.ball;
    let removeBall;
    if (!index && !number && !ball) {
      this.log.info('You cannot delete something that does not exist.');
      return;
    }
    if (!ball) {
      removeBall = this.get({
        index,
        number
      });
    } else {
      removeBall = ball;
    }
    if (removeBall) {
      const tl = gsap.timeline();
      tl.add(removeBall.shrink());
      tl.call(() => {
        let findIndex = index;
        if (removeBall.extraNumber) {
          if (!index) {
            findIndex = _.findIndex(this._extraBalls, {
              number: removeBall.number
            });
          }
          this._extraBalls.splice(findIndex, 1);
        } else {
          if (!index) {
            findIndex = _.findIndex(this._regularBalls, {
              number: removeBall.number
            });
          }
          this._regularBalls.splice(findIndex, 1);
        }
        removeBall.delete();
        this.trigger(svs.tur.ball.row.BALL_REMOVED, this);
      });
      return tl;
    }
  }
  removeAll() {
    for (let i = 0; i < this.balls.length; i++) this.remove({
      ball: this.balls[i]
    });
  }
  addWinInfo() {
    this.winInfo = new svs.tur.ball.row.extensions.WinInfo(this);
    this.$inner.appendChild(this.winInfo.render());
  }
  classNames() {
    const classNames = ['ball-row-default'];
    if (this.align && this.align !== 'undefined') {
      classNames.push("ball-row-align-".concat(this.align));
    }
    return classNames;
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    return this.$el;
  }
  markAsWin() {
    if (!this.isWin) {
      this.addClass('ball-row-win');
      this.isWin = true;
    }
    this.wave();
  }
  unmarkAsWin() {
    if (this.isWin) {
      this.removeClass('ball-row-win');
      this.isWin = false;
    }
  }
  hideNumbers() {
    this.balls.forEach(ball => {
      ball.hideNumber();
    });
  }
  wave() {
    return Animations.wave(this);
  }
  fadeIn() {
    return Animations.fadeIn(this);
  }
  rollIn() {
    return Animations.rollIn(this);
  }
  slideIn() {
    return Animations.slideIn(this);
  }
  get balls() {
    return [...this._regularBalls, ...this._extraBalls];
  }
  clear() {
    return Animations.clear(this);
  }
  reset() {
    if (this.winInfo) {
      this.winInfo.reset();
    }
    if (this.winPlan) {
      this.removeClass('ball-row-win', 'ball-row-skip');
      this.winPlan.reset();
    }
    this.balls.forEach(ball => {
      ball.delete();
    });
    this._regularBalls = [];
    this._extraBalls = [];
  }
  prepare(huxfluxToNumbers) {
    if (huxfluxToNumbers) {
      this._huxfluxToNumbers = [];
      this.balls.forEach((ball, i) => {
        ball.prepare(huxfluxToNumbers[i]);
      });
      this._huxfluxPrepared = true;
    } else {
      this.log.error('You must supply numbers');
    }
  }
  huxflux() {
    let random = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this._huxfluxPrepared) {
      this._huxfluxPrepared = false;
      this.huxfluxComplete();
      this._huxfluxTimeline = HuxFluxAnimations.start({
        row: this,
        random
      });
      return this._huxfluxTimeline;
    }
    return false;
  }
  huxfluxComplete() {
    if (this._huxfluxTimeline && this._huxfluxTimeline.isActive()) {
      this._huxfluxTimeline.progress(1);
    }
  }
  sort() {
    let order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : svs.tur.ball.row.sorter.SORT_NUMERICAL;
    if (!this.sorter) {
      this.sorter = new svs.tur.ball.row.sorter.Balls({
        elements: this.balls
      });
    }
    this.sorter.sort(order);
  }
  spliceIn(_ref5) {
    let number = _ref5.number,
      index = _ref5.index,
      extraNumber = _ref5.extraNumber,
      _ref5$replace = _ref5.replace,
      replace = _ref5$replace === void 0 ? true : _ref5$replace;
    let balls, $balls;
    if (extraNumber) {
      balls = this._extraBalls;
      $balls = this.$ballsExtra;
    } else {
      balls = this._regularBalls;
      $balls = this.$ballsRegular;
    }
    if (typeof index !== 'number') index = _.findIndex(balls, ball => !ball.number);
    const insertBefore = $balls.children[index];
    const addBall = this.createBall({
      number,
      extraNumber
    });
    if (replace) {
      const lastIndex = balls.length - 1;
      const removeBall = balls[lastIndex];
      balls.splice(lastIndex, 1);
      balls.splice(index, 0, addBall);
      $balls.insertBefore(addBall.render(), insertBefore);
      removeBall.delete();
    } else {
      balls.splice(index, 0, addBall);
      $balls.insertBefore(addBall.render(), insertBefore);
    }
    return addBall;
  }
  spliceOut(_ref6) {
    let number = _ref6.number,
      index = _ref6.index,
      extraNumber = _ref6.extraNumber,
      _ref6$replace = _ref6.replace,
      replace = _ref6$replace === void 0 ? true : _ref6$replace;
    let balls, $balls;
    if (extraNumber) {
      balls = this._extraBalls;
      $balls = this.$ballsExtra;
    } else {
      balls = this._regularBalls;
      $balls = this.$ballsRegular;
    }
    if (typeof index !== 'number') index = _.findIndex(balls, ball => ball.number === number);
    const removeBall = balls[index];
    if (removeBall.number === number) {
      const tl = gsap.timeline({
        callbackScope: this,
        onComplete() {
          removeBall.delete();
          if (replace) {
            const emptyBall = this.createBall({
              empty: true,
              extraNumber
            });
            balls.push(emptyBall);
            const emptyBallEl = emptyBall.render();
            $balls.append(emptyBallEl);
            emptyBall.grow();
          }
        }
      });
      balls.splice(index, 1);
      tl.add(removeBall.shrink());
    }
  }
  addHuxfluxed(_ref7) {
    let number = _ref7.number,
      index = _ref7.index,
      extraNumber = _ref7.extraNumber,
      replace = _ref7.replace;
    const ball = this.spliceIn({
      number,
      index,
      extraNumber,
      replace
    });
    ball._huxfluxToNumber = number;
    ball.huxflux();
  }
}
svs.tur.ball.row.Default = Default;
svs.tur.ball.row.BALL_REMOVED = 'ball:removed';

 })(window);